<template>
  <div>
    <div style="margin:20px 25px 0 20px" v-show="!mapConfig.open">
      <el-row class="func-4-item">
        <el-col :span="14" v-if="totalRegistros">
          <h2 class="func-4-title-header">Resultados da busca ({{ totalRegistros }})</h2>
        </el-col>
        <el-col :span="10" class="text-right">
          <el-button
            type="text"
            class="item-button"
            :style="`color: ${estilo.aplicacao.corPrimariaAplicacao};`"
            @click="openMap"
            v-if="redeCredenciada && redeCredenciada.length > 0"
          >
            <div class="text-side-button">
              <i class="el-icon-map-location" style="font-size: 16px" />
              <span class="text-button">Ver no Mapa</span>
            </div>
          </el-button>
          <el-button
            type="text"
            class="item-button"
            :style="`color: ${estilo.aplicacao.corPrimariaAplicacao};`"
            v-if="redeCredenciada && redeCredenciada.length > 0 && false"
          >
            <!-- FIXME: 27/09/2022 martinazzi Desabilitando o imprimir temporáriamente por naõ funcionar -->
            <div class="text-side-button" @click="print()">
              <i class="el-icon-printer" style="font-size: 16px" />
              <span class="text-button">
                Imprimir
              </span>
            </div>
          </el-button>
        </el-col>

      </el-row>

      <Func4Filters/>

      <el-row v-if="redeCredenciada && redeCredenciada.length > 0">
        <el-collapse v-model="activeNames" class="func-listagens" v-if="funcParametros.utilizaSecoes">
          <el-collapse-item v-for="(secao, index) in secoesRedeCredenciada" :key="index" :name="secao.codigo_secao"
                            class="func-4-li" style="margin-top: 0; cursor:pointer">
            <template slot="title" class="func-4-item">
              <el-col :span="22">
                <h2 class="func-4-title" style="margin-left: 13px">
                  <span>{{ secao.descricao_secao }}</span>
                  <span class="total-registro-secao"> ({{ secao.totalRegistrosSecao }})</span>
                </h2>
              </el-col>
              <el-col :span="2" class="text-center">
                <el-button type="text" @click.stop="showDialog = true; dialogData = secao"
                           v-if="secao.detalhamento_secao">
                  <svgIcone icone="Dash_informacoes" :cor="estilo.aplicacao.corPrimariaAplicacao" :width="20"
                            :height="20" />
                </el-button>
              </el-col>
            </template>

            <ul class="func-listagens" v-if="secao.credenciados.length > 0">
              <li v-for="(prestador, index) in secao.credenciados" :key="index" :name="index" class="func-4-li"
                  style="cursor:pointer">
                <div @click="detalhe(prestador)">
                  <el-row class="func-4-item">
                    <el-row>
                      <el-col :span="19">
                        <h2 class="func-4-title">{{ prestador.nome }}</h2>
                        <Func4Acreditacao :acreditacoes="prestador.acreditacoes" />
                        <el-row class="lista-prestador-content">
                          <span class="especialidade">{{ prestador.esp }}</span>
                            <div>
                              <i class="el-icon-location-outline endereco-icon"></i>
                              <span class="endereco">{{ formatEnderecoListPrestador(prestador) }}</span>
                              <span class="distancia">{{ formatDistancia(prestador.distancia) }}</span>
                            </div>
                        </el-row>
                      </el-col>
                      <el-col :span="5" class="listagem-status">
                        <AcoesRedeCredenciada v-if="isWidget" :row="prestador" :abre-detalhe="detalhe"></AcoesRedeCredenciada>
                        <div class="lista-prestador-col-detalhes">
                          <span>{{ prestador.tel }}</span>
                          <span v-if="prestador.tel_sec">{{ prestador.tel_sec }}</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <Func4DetalheAlerta :alert="prestador.mensagem_alerta"/>
                    </el-row>
                  </el-row>
                </div>
              </li>
            </ul>

            <ul class="func-listagens" v-if="secao.credenciados.length === 0">
              <li class="func-4-li">
                <el-row class="func-4-item">
                  <el-col :span="24">
                    <span class="sub">Nenhum credenciado encontrado.</span>
                  </el-col>
                </el-row>
              </li>
            </ul>
          </el-collapse-item>
        </el-collapse>

        <div v-else>
          <ul class="func-listagens lista-prestadores" v-if="redeCredenciada.length > 0">
            <li v-for="(prestador, index) in redeCredenciada" :key="index" :name="index" class="func-4-li"
                style="cursor:pointer">
              <div @click="detalhe(prestador)">
                <el-row class="func-4-item">
                  <el-row>
                    <el-col :span="19">
                      <h2 class="func-4-title">{{ prestador.nome }}</h2>
                      <Func4Acreditacao :acreditacoes="prestador.acreditacoes" />
                      <el-row class="lista-prestador-content">
                        <span class="especialidade">{{ formatEspecialidade(prestador) }}</span>
                          <div>
                            <i class="el-icon-location-outline endereco-icon"></i>
                            <span class="endereco">{{ formatEnderecoListPrestador(prestador) }}</span>
                            <span class="distancia">{{ formatDistancia(prestador.distancia) }}</span>
                          </div>
                      </el-row>
                    </el-col>
                    <el-col :span="5" class="listagem-status">
                      <AcoesRedeCredenciada v-if="isWidget" :row="prestador" :abre-detalhe="detalhe"></AcoesRedeCredenciada>
                      <div class="lista-prestador-col-detalhes">
                        <span>{{ prestador.tel }}</span>
                        <span v-if="prestador.tel_sec">{{ prestador.tel_sec }}</span>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <Func4DetalheAlerta :alert="prestador.mensagem_alerta"/>
                  </el-row>
                </el-row>
              </div>
            </li>
          </ul>
          <ul class="func-listagens" v-if="redeCredenciada.length === 0">
            <li class="func-4-li">
              <el-row class="func-4-item">
                <el-col :span="24">
                  <span class="sub">Nenhum credenciado encontrado.</span>
                </el-col>
              </el-row>
            </li>
          </ul>
        </div>

        <div>
          <el-row class="func-4-item" style="margin-top: 20px">
            <el-row>
              <el-col :span="24">
                <h2 class="func-4-title">
                  Legenda da acreditação
                </h2>
              </el-col>
            </el-row>
            <ul class="func-listagens" v-if="acreditacoesLegenda && acreditacoesLegenda.length > 0"
                style="padding-top: 20px">
              <li
                v-for="(acreditacao, index) in acreditacoesLegenda"
                :key="index">
                <el-row class="func-4-item-acreditacao-legenda">
                  <el-col :span="24">
                    <img :src="acreditacao.icone" /> <span class="sub-acreditacao-legenda">
                    {{ acreditacao.resumo }}
                  </span>
                  </el-col>
                </el-row>
              </li>
            </ul>
          </el-row>
        </div>
      </el-row>

      <el-row v-else-if="redeCredenciada && redeCredenciada.length === 0 && !loading">
        <ErrorVazio :titulo="errorVazio.titulo" :texto="errorVazio.texto" :showBtn="false" />
      </el-row>

      <el-row v-if="serverError">
        <ErrorCarregar />
      </el-row>
    </div>

    <Func4ListagemMapa ref="mapRef" v-if="redeCredenciada && redeCredenciada.length > 0"
                       :redeCredenciada="redeCredenciada" :locations="locations" :config="mapConfig" />
    <DialogDefault :title="dialogData.descricao_secao" :open.sync="showDialog" width="40%" :top="`11%`"
                   :closeOnClickModal="false">
      <el-row>
        <el-col :span="24">
          <div v-html="dialogData.detalhamento_secao"></div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" style="padding-top:15px; padding-bottom: 15px">
          <p class="default-dialog-close text-center" @click="showDialog = false">
            ENTENDI
          </p>
        </el-col>
      </el-row>
    </DialogDefault>
  </div>

</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import Func4ListagemMapa from '@/views/4/ListagemMapa'
import Func4DetalheAlerta from '@/views/4/DetalheAlerta'
import ErrorCarregar from '@/components/Error/ErrorCarregar'
import ErrorVazio from '@/components/Error/ErrorVazio'
import DialogDefault from '@/components/DialogDefault/DialogDefault'
import Func4Acreditacao from '@/views/4/Acreditacao'
import AcoesRedeCredenciada from '@/views/4/AcoesRedeCredenciada.vue'
import Func4Filters from '@/views/4/Filters.vue'

export default {
  name: 'Func4RedeCredenciadaListagem',
  components: {
    Func4Filters,
    AcoesRedeCredenciada,
    Func4Acreditacao,
    Func4ListagemMapa,
    Func4DetalheAlerta,
    ErrorCarregar,
    ErrorVazio,
    DialogDefault
  },
  data () {
    return {
      dialogData: {},
      reqError: true,
      refreshData: true,
      showDialog: false,
      mapConfig: {
        height: '634px',
        open: false,
        showActions: false,
        showCardInfo: true,
        showHeader: true,
        zoom: 12
      },
      errorVazio: {
        titulo: 'Nenhum resultado encontrado',
        texto: 'Experimente outras opções de pesquisa e tente novamente'
      }
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade']),
    ...mapGetters('Login', ['token', 'user']),
    ...mapGetters('SetupApp', ['estilo', 'aplicacao', 'configuracaoAcesso', 'isWidget']),
    ...mapGetters('RedeCredenciada', ['redeCredenciada', 'locations', 'loading', 'serverError', 'acreditacoesLegenda', 'totalRegistros']),
    ...mapFields('RedeCredenciada', ['activeNames']),
    clientKey () {
      return this.user && this.user.selectedClient && this.user.selectedClient.clientKey
    },
    estiloLinha () {
      return `background: ${this.estilo.aplicacao.corPrimariaAplicacao}0d !important`
    },
    corPrimariaAplicacao () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    funcParametros () {
      return this.funcionalidade.parametros
    },
    secoesRedeCredenciada () {
      let secoes = []
      if (this.redeCredenciada && this.funcParametros.utilizaSecoes) {
        if (this.funcParametros.exibeSecoesVazias) {
          secoes = this.redeCredenciada
        } else {
          this.redeCredenciada.forEach(s => {
            if (s.totalRegistrosSecao > 0) {
              secoes.push(s)
            }
          })
        }
      }
      return secoes
    }
  },
  methods: {
    ...mapActions('RedeCredenciada', ['setViewDetalhe', 'setViewPrint', 'setPrintType', 'setPrestador']),
    formatEspecialidade (prestador) {
      if (prestador.subespec) {
        return prestador.esp + ', ' + prestador.subespec
      }
      return prestador.esp
    },
    detalhe (prestador) {
      this.setPrestador(prestador)
      this.setViewDetalhe(true)
      this.$router.push({ path: `/4`, query: { detalhe: prestador.id } })
    },
    openMap () {
      this.mapConfig.open = true
      this.$refs.mapRef.initLocations()
    },
    print () {
      this.setPrintType('list')
      this.setViewPrint(true)
    },
    formatToMeters (distancia) {
      let metros = distancia * 1000
      metros = parseInt(metros)
      return `${metros} m`
    },
    formatToKm (distancia) {
      let km = distancia.toFixed(1)
      return `${km} km`
    },
    formatDistancia (distancia) {
      let formatedDistance = ''
      if (!distancia) {
        return formatedDistance
      }
      if (distancia < 1) {
        formatedDistance = this.formatToMeters(distancia)
      } else {
        formatedDistance = this.formatToKm(distancia)
      }
      return formatedDistance
    },
    formatEnderecoListPrestador (prestador) {
      let endereco = ''
      if (prestador.endereco) {
        endereco += prestador.endereco

        if (prestador.numero) {
          endereco += ', ' + prestador.numero
        }
        if (prestador.complemento) {
          endereco += ' - ' + prestador.complemento
        }
        if (prestador.bairro) {
          endereco += ', ' + prestador.bairro
        }
        if (prestador.cid) {
          endereco += ', ' + prestador.cid
        }
      }
      return endereco
    }
  }
}

</script>

<style lang="less">

#func-4 {
  #detalhes-wrapper {
    display: flex;
    place-items: baseline;
    place-content: flex-end;
  }

  .el-collapse-item__header {
    background-color: var(--cor-primaria-aplicacao-transparent);
    border-top: 1px solid #EEEEEE !important;
    border-bottom: 1px solid var(--cor-primaria-aplicacao) !important;
  }

  .func-4-li {
    .el-icon-arrow-right {
      color: var(--cor-primaria-aplicacao);
    }
    .lista-prestador-content {
      display: flex;
      flex-direction: column;
      gap: 5px;
      font-size: 14px;

      .endereco {
        font-weight: 600;
        font-size: 12px;
      }

      .endereco-icon {
        color: #8D8D8D;
        font-size: 15px;
        margin-right: 6px;
      }

      .distancia {
        font-weight: 600;
        font-size: 12px;
        color: var(--cor-primaria-aplicacao);
        margin-left: 26px;
      }

      .especialidade {
        color: #888888;
      }
    }
    .lista-prestador-col-detalhes {
      display: flex;
      flex-direction: column;
      gap: 5px;
      font-size: 14px;
      align-items: flex-end;
    }
  }
}

</style>
